require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./racismo-y-homofobia-en-el-futbol-ruso.json") })
        }
      }, "path---racismo-y-homofobia-en-el-futbol-ruso");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---racismo-y-homofobia-en-el-futbol-ruso!./.cache/json/racismo-y-homofobia-en-el-futbol-ruso.json
// module id = 448
// module chunks = 231608221292675